import { Injectable } from '@angular/core';
import { Router, Params, ActivatedRoute, ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Campaign } from './campaign.model';
import { CampaignService } from './campaign.service';


@Injectable()
export class CampaignGuard implements Resolve<Campaign> {

  constructor(public router: Router, private campaignService: CampaignService) { }

  private campaignId: string;

  resolve(route: ActivatedRouteSnapshot) {
    this.campaignId = route.params['campaignId'];
    return this.campaignService.getCampaignById(this.campaignId);
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/campaign/campaign.guard.ts